import { Box, SystemProps, Stack } from '@storyofams/react-ui';
import SbEditable from 'storyblok-react';

import { Heading, Button } from '~components';
import { getLinkProps } from '~lib';

import { DynamicSectionContainer, RichText } from '../dynamic';

type TextBlockProps = {
  content: {
    title?: string;
    text: any;
    alignment: 'left' | 'center';
    button_link: any;
    button_label: string;
  };
  first?: boolean;
} & SystemProps;

export const TextBlock = ({ content, first, ...props }: TextBlockProps) => {
  const startsWithBulletPoints =
    !!content?.text?.content?.[0]?.content?.[0]?.content?.[0]?.content[0]?.text;

  return (
    <SbEditable content={content as any}>
      <DynamicSectionContainer maxWidth="760px" {...props}>
        <Stack space={3} flexDirection="column" textAlign={content?.alignment}>
          {!!content?.title && (
            <Heading as={first ? 'h1' : 'h2'} variant="h3" fontSize={[5, 8]}>
              {content?.title}
            </Heading>
          )}
          {(!!content?.text?.content?.[0]?.content?.[0]?.text ||
            (content?.button_label && content?.button_link) ||
            startsWithBulletPoints) && (
            <Box>
              {(!!content?.text?.content?.[0]?.content?.[0]?.text ||
                startsWithBulletPoints) && <RichText text={content?.text} />}
              {content?.button_label && content?.button_link && (
                <Button
                  variant="primary"
                  {...getLinkProps(content.button_link)}
                  mt={3}
                  css={{ display: 'inline-flex' }}
                >
                  {content?.button_label}
                </Button>
              )}
            </Box>
          )}
        </Stack>
      </DynamicSectionContainer>
    </SbEditable>
  );
};
